import { cn } from "@repo/ui/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const textareaVariants = cva("", {
  variants: {
    variant: {
      default: "",
      transparent:
        "not-hover:not-focus-visible:bg-transparent dark:not-hover:not-focus-visible:bg-transparent border-transparent shadow-none focus-visible:ring-0 focus-visible:border-transparent hover:text-accent-foreground focus-visible:text-accent-foreground",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

function Textarea({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<"textarea"> & VariantProps<typeof textareaVariants>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "field-sizing-content flex min-h-16 w-full resize-none rounded-md border border-input bg-input/20 px-2 py-2 text-sm outline-none transition-colors placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-2 aria-invalid:ring-destructive/20 md:text-xs/relaxed dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        "no-scrollbar",
        textareaVariants({ variant }),
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
